export default __webpack_public_path__ + "035f4818da90a06104479ac46ededee7.svg";